"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const ecommerce_1 = require("../../../api/ecommerce");
const LoadingSpinner_1 = __importDefault(require("../../../common/js/components/LoadingSpinner"));
const translation_1 = require("../../../common/js/helper/translation");
const Select_1 = __importDefault(require("../../atoms/Select"));
const Paths_1 = require("../../constants/Paths");
const history_1 = require("../../helper/history");
const sorting_1 = require("../../helper/sorting");
const SortingPropertyModel_1 = require("../../models/SortingPropertyModel");
const ShopwareProductSearch_1 = __importDefault(require("../../stores/ShopwareProductSearch"));
const ProductList_1 = __importDefault(require("../ProductList"));
class ShopSearchResult extends react_1.default.Component {
    products = [];
    isLoading = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            products: mobx_1.observable,
            isLoading: mobx_1.observable,
            searchTerm: mobx_1.computed,
            sortingPropertyKey: mobx_1.computed,
            sortableProperties: mobx_1.computed,
            sortableOptions: mobx_1.computed,
        });
    }
    get searchTerm() {
        try {
            return decodeURIComponent(this.props.match.params.searchTerm);
        }
        catch (_e) {
            return this.props.match.params.searchTerm;
        }
    }
    componentDidMount() {
        document.title = (0, translation_1.t)('shop_subpage_title', {
            title: (0, translation_1.t)('search_result_page.page_title', { searchTerm: this.searchTerm }),
        });
        this.loadProducts();
    }
    componentDidUpdate(prevProps) {
        document.title = (0, translation_1.t)('shop_subpage_title', {
            title: (0, translation_1.t)('search_result_page.page_title', { searchTerm: this.searchTerm }),
        });
        if (prevProps.match.params.searchTerm === this.props.match.params.searchTerm) {
            return;
        }
        this.loadProducts();
    }
    render() {
        return (react_1.default.createElement("section", { className: "znd-shop-search-result-page" },
            react_1.default.createElement("div", { className: "znd-shop-search-result-page__content" },
                react_1.default.createElement("div", { className: "znd-shop-search-result-page__header d-flex justify-content-between align-items-start flex-column align-items-sm-center flex-sm-row" },
                    react_1.default.createElement("div", { className: "znd-shop-search-result-page__header-left" },
                        react_1.default.createElement("div", { className: "znd-shop-search-result-page__header__title t-headline-2" }, (0, translation_1.t)('search_result_page.page_title', { searchTerm: this.searchTerm })),
                        react_1.default.createElement("div", { className: "znd-shop-search-result-page__header__subtitle" }, (0, translation_1.t)('search_result_page.title', {
                            productCount: this.isLoading ? '…' : this.products.length,
                        }))),
                    this.products.length > 0 ? (react_1.default.createElement("div", { className: "znd-header-page-right" },
                        react_1.default.createElement(Select_1.default, { label: (0, translation_1.t)('select.product_sort.description'), value: this.sortingPropertyKey, options: this.sortableOptions, onChange: (sort) => {
                                (0, history_1.pushHistory)(this.props.history, this.props.location.pathname + `?sort=${sort}`);
                            } }))) : null),
                this.products.length > 0 ? (react_1.default.createElement("div", { className: "znd-shop-search-result-page__product-list-wrapper" }, this.isLoading ? (react_1.default.createElement("div", { className: "d-flex justify-content-center align-items-center vh-100" },
                    react_1.default.createElement(LoadingSpinner_1.default, null))) : (react_1.default.createElement(ProductList_1.default, { products: this.products, sortingProperty: this.sortableProperties.find((p) => this.sortingPropertyKey === p.key) })))) : null)));
    }
    loadProducts() {
        if (!this.searchTerm?.length) {
            (0, history_1.replaceHistory)(this.props.history, Paths_1.PATH_SHOP);
            return;
        }
        this.isLoading = true;
        ShopwareProductSearch_1.default
            .searchProducts({
            search: this.searchTerm,
            page: 1,
            limit: 500,
        })
            .then((productList) => {
            this.products = productList.elements ?? [];
        })
            .finally(() => {
            this.isLoading = false;
        });
    }
    get sortingPropertyKey() {
        return new URLSearchParams(this.props.location.search).get('sort') ?? ecommerce_1.ProductSearchRequestBodySortEnum.Score;
    }
    get sortableProperties() {
        const sortingProperties = [
            {
                direction: SortingPropertyModel_1.SortingDirection.desc,
                key: 'score',
                position: -5,
                property: 'score',
                type: SortingPropertyModel_1.SortingType.text,
            },
        ];
        return sortingProperties.concat((0, sorting_1.defaultSortingProperties)());
    }
    get sortableOptions() {
        return this.sortableProperties
            .map((p) => {
            return {
                key: p.key,
                position: p.position,
                name: p.name
                    ? p.name
                    : (0, translation_1.t)(`select.product_sort.direction.${p.direction}`, {
                        type: p.type,
                        property: (0, translation_1.t)(`select.product_sort.property.${p.property}`),
                    }),
            };
        })
            .sort((a, b) => a.position - b.position)
            .reduce((options, option) => {
            return {
                ...options,
                [option.key]: option.name,
            };
        }, {});
    }
}
exports.default = (0, mobx_react_1.observer)(ShopSearchResult);
